"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointsToBreakpointRanges = void 0;
const forEach_1 = __importDefault(require("lodash/forEach"));
const isNull_1 = __importDefault(require("lodash/isNull"));
const breakpointsToBreakpointRanges = (breakpoints) => {
    const filteredBreakpoints = {};
    (0, forEach_1.default)(breakpoints, (v, k) => {
        if (!(0, isNull_1.default)(v)) {
            filteredBreakpoints[k] = parseInt(v);
        }
    });
    const sortedBreakpointValues = Object.values(filteredBreakpoints).sort((a, b) => a - b);
    const breakpointsRanges = {};
    (0, forEach_1.default)(filteredBreakpoints, (max, key) => {
        const maxIndex = sortedBreakpointValues.findIndex((v) => v === max);
        breakpointsRanges[key] = [
            maxIndex - 1 >= 0 ? sortedBreakpointValues[maxIndex - 1] + 1 : undefined,
            maxIndex === sortedBreakpointValues.length - 1 ? undefined : max
        ];
    });
    return breakpointsRanges;
};
exports.breakpointsToBreakpointRanges = breakpointsToBreakpointRanges;
